module.exports = __webpack_public_path__ + "static/slide-1-3eda909a8ee279e833b45b9e24daac34.jpg";